<template>
  <detail
    :on-manager="onManager"
    :data="{...data, project_domain: data.domain, tenant: data.project }"
    resource="meter_instance_caches"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    :hiddenKeys="['status']" />
</template>

<script>
import { getBillBrandTableColumn } from '@/utils/common/tableColumn'
import {
  getUserTagColumn,
  getExtTagColumn,
} from '@/utils/common/detailColumn'
import WindowsMixin from '@/mixins/windows'
import { getBillResourceTypeLabel } from '@Bill/utils'

export default {
  name: 'ResourceTagDetail',
  mixins: [WindowsMixin],
  props: {
    onManager: {
      type: Function,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      baseInfo: [
        getUserTagColumn({ onManager: this.onManager, resource: 'meter_instance_caches', columns: () => this.columns, tipName: this.$t('bill.resource_tag'), editCheck: () => false }),
        getExtTagColumn({ onManager: this.onManager, resource: 'meter_instance_caches', columns: () => this.columns, tipName: this.$t('bill.resource_tag'), editCheck: () => false }),
        getBillBrandTableColumn(),
        {
          field: 'resource_type',
          title: this.$t('bill.resource_tag.resource_type'),
          minWidth: 50,
          formatter: ({ row }) => {
            return getBillResourceTypeLabel(row.resource_type)
          },
        },
        {
          field: 'origin_res_type',
          title: this.$t('bill.resource_tag.origin_resource_type'),
          minWidth: 50,
          slots: {
            default: ({ row }, h) => {
              return row.origin_res_type || '-'
            },
          },
        },
      ],
      extraInfo: [],
    }
  },
}
</script>
